// extracted by mini-css-extract-plugin
module.exports = {"dialogContainer":"DialogContainer__dialogContainer___3ZOrd","desktop":"DialogContainer__desktop___Yky9F","mobile":"DialogContainer__mobile___7BVwC"};